import style from './index.module.scss'

const Notification = ({ data }) => {
  return (
    <div className={style.block}>
      {
        data.image &&
        <img
          className={style.image}
          src={data.image}
          alt={data?.title}
        />
      }
      <div dangerouslySetInnerHTML={{ __html: data?.text }} />
    </div>
  )
}

export default Notification
